import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function ProgramsPage() {
    const { t } = useLang();
    const [programs, setPrograms] = useState([]);

    useEffect(() => {
        api.get("/programs").then((r) => setPrograms(r.data)).catch(() => {});
    }, []);

    return (
        <div data-testid="programs-page" className="px-6 md:px-12 lg:px-20 py-16">
            <div className="mb-12">
                <div className="font-body text-xs uppercase tracking-[0.25em] text-volt mb-3">
                    Elite Player Academy
                </div>
                <h1 className="text-5xl md:text-6xl font-heading uppercase">{t("programs_title")}</h1>
                <p className="mt-4 text-white/60 max-w-2xl">{t("programs_sub")}</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {programs.map((p) => (
                    <Link key={p.id} to={`/programs/${p.id}`}
                          data-testid={`program-card-${p.id}`}
                          className="group bg-zinc-900 border border-white/10 overflow-hidden hover:border-volt/50 hover:-translate-y-1 transition-all flex flex-col">
                            <div className="aspect-video overflow-hidden bg-black">
                                {p.thumbnail_url && (
                                    <img src={p.thumbnail_url} alt={p.title}
                                         className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500" />
                                )}
                            </div>
                        <div className="p-6 flex-1 flex flex-col">
                            <div className="flex items-center gap-2 mb-3">
                                <span className="text-xs uppercase tracking-widest text-volt">
                                    {p.duration_weeks} {t("weeks")}
                                </span>
                                <span className="w-1 h-1 bg-white/30 rounded-full" />
                                <span className="text-xs uppercase tracking-widest text-white/50">
                                    {t("age")}: {p.age_min}+
                                </span>
                            </div>
                            <div className="font-heading text-2xl uppercase">{p.title}</div>
                            <div className="font-body text-sm text-white/60 mt-2 flex-1">{p.subtitle}</div>
                            {p.price_eur > 0 && (
                                <div className="mt-4 font-heading text-2xl text-volt">
                                    {p.price_eur.toFixed(2)} €
                                </div>
                            )}
                            <div className="mt-4 text-xs uppercase tracking-widest text-white/50 group-hover:text-volt flex items-center gap-1">
                                {t("open_program")} <ArrowUpRight size={14} />
                            </div>
                        </div>
                    </Link>
                ))}

                {/* Coming Soon placeholder */}
                <div className="border border-dashed border-white/10 bg-zinc-900/40 p-10 flex flex-col items-center justify-center min-h-[300px]"
                     data-testid="coming-soon-card">
                    <div className="font-heading text-volt text-xs tracking-[0.25em] mb-3">
                        {t("next_programs")}
                    </div>
                    <div className="font-heading text-3xl uppercase text-white/80 text-center">
                        {t("coming_soon")}
                    </div>
                </div>
            </div>
        </div>
    );
}
